export default "__VITE_ASSET__275281a3__"